import React, { useState } from "react"
import { Link } from "react-router-dom"
import "./products.css"

function BtnCellRenderer(props) {
  return (
    <>
      <div className="row">
        <div className="col">
          <Link
            to={`edit/` + props.data.material_standard_id}
            className="text-decoration-none"
          >
            <i
              className="bx bx-edit cursor-pointer font_size_large"
              title="Edit Material Standard"
            ></i>
          </Link>
        </div>
      </div>
    </>
  )
}

export default BtnCellRenderer
